import type { CustomField } from '@libs/domain';
import { genMstColumns, mstListSearchFieldConfig } from '@libs/templates/mst';
import type { PageProps } from '@ps-smart-cp/ppfw-client';
import { withRerender } from '@ps-smart-cp/ppfw-client';
import { CustomMstMaintenanceTempTmpl } from './components';
import { useCustomFieldBasicSettings } from './hooks';
import { CustomMstListSearch } from './models';
import type { CustomMstRegistration } from './models';
import { listRequest, remove } from './repositories';
import { createCustomMstItemName } from './services';

function PageComponent({
  customFieldKey,
  ...restProps
}: PageProps & Pick<CustomField['schema'], 'customFieldKey'>) {
  const customFieldSettings = useCustomFieldBasicSettings();

  // TODO: カスタムマスタ取込・出力対応時に修正 (https://proship-infra.atlassian.net/browse/AFW-306)
  return (
    <CustomMstMaintenanceTempTmpl
      mstName={createCustomMstItemName(customFieldKey, customFieldSettings)}
      columns={genMstColumns<CustomMstRegistration>()}
      items={mstListSearchFieldConfig}
      listRequestFunction={listRequest(customFieldKey)()}
      initMst={CustomMstListSearch.init}
      deleteFunction={remove(customFieldKey)()}
      {...restProps}
    />
  );
}

const Maintenance = withRerender(PageComponent, 'Maintenance');

export { Maintenance };
